import { DataTableVariant, DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { getDatatableBuilderObjectFactory } from '@/components/data-table-builder/utils/datatable-builder-factory';
import { DynamicForm as Fb, FieldVariant } from '@/components/form-builder/form-builder.types';
import { getFormBuilderObjectFactory } from '@/components/form-builder/utils/form-builder-factory';
import { DynamicForm, DynamicFieldType, DynaStatus } from '@/types';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DynamicFormTransformationService {
  getFieldVariant(dynaFieldType: DynamicFieldType): FieldVariant {
    switch (dynaFieldType) {
      case DynamicFieldType.TEXT:
        return FieldVariant.TEXT;
      case DynamicFieldType.INTEGER:
      case DynamicFieldType.DECIMAL:
        return FieldVariant.NUMBER;
      case DynamicFieldType.DATE:
        return FieldVariant.DATE;
      // case DynamicFieldType.TABLE:
      //   return FieldVariant.CUSTOM;
      // case DynamicFieldType.LIST:
      //   return FieldVariant.TEXT_GROUPS;
      default:
        return FieldVariant.TEXT;
    }
  }

  getFormObject(form: DynamicForm): Fb {
    const formObject: Fb = getFormBuilderObjectFactory();
    formObject.title = form.name;
    formObject.class = 'border p-5 rounded-lg';
    formObject.grids = [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: form.fields.map(field => ({
          fields: [
            {
              label: field.label,
              isDisabled: of(true),
              isRequired: field.isRequired,
              isHidden: of(field.status !== DynaStatus.ACTIF),
              variant: this.getFieldVariant(field.type),
            },
          ],
        })),
      },
    ];
    return formObject;
  }

  getTableObject(form: DynamicForm): DynamicDataTable {
    const datatableObject: DynamicDataTable = getDatatableBuilderObjectFactory();
    datatableObject.singular = form.name;
    datatableObject.plural = form.name;
    datatableObject.variant = DataTableVariant.COMMON;
    datatableObject.columns = form.fields
      .map(field => {
        if (field.status !== DynaStatus.NON_ACTIF)
          return {
            label: field.label,
            accessorKey: field.label,
            type: this.getFieldVariant(field.type),
          };
        return null;
      })
      .filter(column => column !== null);

    return datatableObject;
  }
}
